import React from "react";
import { Box, Typography, Paper, Stack, Button, Chip } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import LockIcon from "@mui/icons-material/Lock";
import OnlinePredictionIcon from "@mui/icons-material/OnlinePrediction";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { MetricCard } from "../shared";

/**
 * Panel de estadísticas de usuarios para Admin Dashboard
 */
export default function UserStatsPanel({ loading, stats, onGoUserManagement }) {
  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h6" fontWeight={600}>
          User Statistics
        </Typography>
        <Button
          size="small"
          endIcon={<ArrowForwardIcon />}
          onClick={onGoUserManagement}
        >
          Manage Users
        </Button>
      </Stack>

      <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(4, 1fr)",
          },
        }}
      >
        <MetricCard
          title="Total Users"
          value={stats.totalUsers}
          icon={<PeopleIcon />}
          color="primary"
          loading={loading}
          onClick={onGoUserManagement}
        />

        <MetricCard
          title="Active Today"
          value={stats.activeToday}
          subtitle={`${((stats.activeToday / stats.totalUsers) * 100).toFixed(0)}% of total`}
          icon={<OnlinePredictionIcon />}
          color="success"
          loading={loading}
        />

        <MetricCard
          title="New This Month"
          value={stats.newThisMonth}
          icon={<PersonAddIcon />}
          color="info"
          loading={loading}
        />

        <MetricCard
          title="Locked Accounts"
          value={stats.lockedAccounts}
          subtitle="Require review"
          icon={<LockIcon />}
          color={stats.lockedAccounts > 0 ? "warning" : "success"}
          loading={loading}
        />
      </Box>

      {/* Users by Role */}
      <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, mt: 2 }}>
        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1.5 }}>
          Users by Role
        </Typography>
        <Stack direction="row" flexWrap="wrap" gap={1}>
          {stats.byRole?.map((item) => (
            <Chip
              key={item.role}
              label={`${item.role}: ${item.count}`}
              variant="outlined"
              size="small"
            />
          ))}
        </Stack>
      </Paper>
    </Box>
  );
}
